import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
//redux
import { useNavigate, useParams } from "react-router-dom";
import { REMOVE_CITY } from "helpers/api_endpoints";

const RemoveCity = () => {
    const history = useNavigate();
    const params = useParams();
    const id = params.id;
    const navigate = useNavigate();

    useEffect(() => {
        del(REMOVE_CITY, { id })
            .then(response => {
                navigate('/cities', { state: { successMsg: 'City deleted successfuly' } });
            })
            .catch(error => {
                console.log(error);
            })
    });

    return <></>;
};

export default withRouter(RemoveCity);